import { MockSearchCustomerFormModel } from './formModel';

export const getInitialValues = (): MockSearchCustomerFormModel => {
  return {
    firstName: undefined,
    lastName: undefined,
    dateOfBirth: undefined,
    email: undefined,
  };
};
